import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  snapDefaultPaper,
  unSnapDefaultPaper,
} from "store/bailiff/(default)/paper/default_paper.action";
import { setHighlight } from "store/bailiff/nav/nav.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  const [searchParams] = useSearchParams();
  const status = searchParams?.get("status") || "all";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(setHighlight(["2"]));
  }, [dispatch]);

  useEffect(() => {
    if (status) {
      dispatch(snapDefaultPaper({ status }));
    }

    return () => dispatch(unSnapDefaultPaper());
  }, [status, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
